<template>
  <div class="hero text-white" :style="`background-image: url(${background})`">
    <b-container class="h-100 d-flex flex-column justify-content-center">
      <b-row>
        <b-col sm="8">
          <h2 v-if="surtitle" class="m-0">
            {{ surtitle }}
          </h2>
          <h1 v-if="title" class="display-3 font-weight-bold py-2">
            {{ title }}
          </h1>
          <!-- <img
            v-if="!title"
            :src="require('@/assets/estudio9-logo.svg')"
            alt="Logo estudio9"
          />
          <h3 v-if="description" class="h5 font-weight-light">
            {{ description }}
          </h3> -->
          <div class="mt-5" v-if="cta">
            <b-button squared variant="light" size="md" class="px-4 py-2">
              {{ cta }}
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <span class="watermark">PH: Marcos Andreini</span>
  </div>
</template>

<script>
export default {
  name: "Hero",
  props: {
    surtitle: String,
    title: String,
    description: String,
    cta: String,
    background: String
  }
};
</script>

<style scoped lang="sass">
.hero
  // height: calc(100vh - 94px)
  height: 100vh
  background-position: center center
  background-repeat: no-repeat
  background-size: cover
  background-color: #555B50
  img
    width: 100%
    max-width: 570px
    filter: brightness(2)
    margin-bottom: 1rem
    padding: 2rem 0
  .watermark
    position: absolute;
    right: 2rem
    bottom: 180px
    font-weight: 300
    letter-spacing: 0.5px
    opacity: 0.6
    filter: drop-shadow(1px 1px 2px black)
  @media screen and (min-width: 1280px)
    h3
      padding-left: 154px
  @media screen and (max-width: 820px)
    .watermark
      bottom: 1rem
  @media screen and (max-width: 502px)
    padding: 0 1rem
    h1
      font-size: 4rem
      line-height: 1
    .watermark
      right: 1rem
      bottom: 1rem
</style>
